import { ActionTypesFactory } from "../../common/redux/actions/ActionTypesFactory";

const userCompanyActionTypes = ActionTypesFactory.crudActionTypes(
  "USER_COMPANY"
);

export default userCompanyActionTypes;
